import React, { useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Switch } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Tick } from "../../../../assets/Icons/tick.svg";
import styled from "styled-components";

const Styleddiv = styled.div`
  table {
    width: 100%;
    margin: 20px 0;
    font-size: 16px;
    border-collapse: separate; /* Important for border-radius to work */
    border-spacing: 0; /* Prevent spacing between table cells */
    border-radius: 8px; /* Add border-radius to the table */
    overflow: hidden;
    border: 1px solid #e2e2e8;
  }
  th,
  td {
    border-left: 1px solid #e2e2e8;
    padding: 10px;
  }

  th {
    background-color: #f9f9f9;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid #e2e2e8;
  }
  th:nth-child(2),
  td:nth-child(2),
  th:nth-child(3),
  td:nth-child(3),
  th:nth-child(4),
  td:nth-child(4),
  th:nth-child(5),
  td:nth-child(5) {
    width: 15%;
    text-align: center;
  }

  .parent-row {
    font-weight: bold;
    // border-bottom: 1px solid #fff !important;
  }

  input[type="checkbox"] {
    margin-right: 10px;
  }

  .multi_table_header {
  }
  tbody tr:nth-child(even) {
    background-color: #f9f9f9; /* Light gray */
  }

  tbody tr:nth-child(odd) {
    background-color: #ffffff; /* White */
  }

  .subrow {
    color: #636980;
    font-size: 14px;
    font-weight: 400;
  }

  .border {
    border-radius: 8px; /* Apply border-radius to nested tables */
    overflow: hidden;
    // border: 1px solid #e2e2e8;
  }

  .people-type {
    cursor: pointer;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #636980;
  }

  .creating-people-type {
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    color: #1f243b;
  }

  .name-text {
    font-size: 14px;
    font-weight: 500;
    color: #636980;
  }

  .permission-text {
    font-size: 16px;
    font-weight: 400;
    color: #1f243b;
    text-align: left;
  }

  .button-style {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 80%;
    margin-left: 271px;
    background-color: white;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 20px;
    padding-top: 20px;
    box-shadow: 0px -1px 5px rgba(0, 0, 0, 0.2);
  }

  .cancel-button {
    width: 130px;
    height: 34px;
    border: 1px solid #1f243b;
    border-radius: 8px;
    transition: none !important;
  }

  .save-button {
    background-color: #c2fae5;
    width: 130px;
    height: 34px;
    border-radius: 8px;
    color: black;
    transition: none !important;
  }

  .cancel-button:hover,
  .cancel-button:active {
    border: 1px solid #1f243b !important;
    color: #1f243b !important;
  }

  .save-button:hover,
  .save-button:active {
    background-color: #c2fae5 !important;
    color: #1f243b !important;
  }

  .ant-switch-checked {
    background-color: #03c83e !important; /* Green color */
  }
`;
const EditPeople = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [visibleGroups, setVisibleGroups] = useState({
    Administrator: false,
    Tutor: false,
    Learner: false,
  });
  const [modalVisible, setModalVisible] = useState(false);

  const [groups, setGroups] = useState([
    {
      name: "Administrator",
      subRows: [
        {
          name: "Dashboard",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Course",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Course List",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "People",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Group",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          subName: "Report",
          subItems: [
            {
              name: "People",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Course",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Group",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Course Task",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Activity Log",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
          ],
        },
        {
          subName: "Settings",
          subItems: [
            {
              name: "Account",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "People",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Course",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Category",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
          ],
        },
      ],
    },
    {
      name: "Tutor",
      subRows: [
        {
          name: "Dashboard",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Course",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Group",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Scoring",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Conference",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          subName: "Report",
          subItems: [
            {
              name: "Course",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Course Task",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
            {
              name: "Activity Log",
              permissions: {
                view: false,
                create: false,
                modify: false,
                delete: false,
              },
            },
          ],
        },
        {
          name: "Calender",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
      ],
    },
    {
      name: "Learner",
      subRows: [
        {
          name: "Dashboard",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "My Course",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Course List",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
        {
          name: "Calender",
          permissions: {
            view: false,
            create: false,
            modify: false,
            delete: false,
          },
        },
      ],
    },
  ]);

  const toggleVisibility = (group) => {
    setVisibleGroups((prevState) => ({
      ...prevState,
      [group]: !prevState[group],
    }));
  };
  console.log("groups--->", groups);

  const toggleSubNamePermissions = (groupIndex, rowIndex) => {
    setGroups((prevGroups) =>
      prevGroups.map((group, gIdx) =>
        gIdx === groupIndex
          ? {
              ...group,
              subRows: group.subRows.map((row, rIdx) =>
                rIdx === rowIndex && row.subItems
                  ? {
                      ...row,
                      subItems: row.subItems.map((subItem) => ({
                        ...subItem,
                        permissions: {
                          view: !row.subItems.every((item) =>
                            Object.values(item.permissions).every(
                              (perm) => perm
                            )
                          ),
                          create: !row.subItems.every((item) =>
                            Object.values(item.permissions).every(
                              (perm) => perm
                            )
                          ),
                          modify: !row.subItems.every((item) =>
                            Object.values(item.permissions).every(
                              (perm) => perm
                            )
                          ),
                          delete: !row.subItems.every((item) =>
                            Object.values(item.permissions).every(
                              (perm) => perm
                            )
                          ),
                        },
                      })),
                    }
                  : row
              ),
            }
          : group
      )
    );
  };

  const togglePermission = (
    groupIndex,
    rowIndex,
    permission,
    subItemIndex = null
  ) => {
    setGroups((prevGroups) =>
      prevGroups.map((group, gIdx) =>
        gIdx === groupIndex
          ? {
              ...group,
              subRows: group.subRows.map((row, rIdx) =>
                rIdx === rowIndex
                  ? {
                      ...row,
                      ...(subItemIndex !== null
                        ? {
                            subItems: row.subItems.map((subItem, sIdx) =>
                              sIdx === subItemIndex
                                ? {
                                    ...subItem,
                                    permissions: {
                                      ...subItem.permissions,
                                      [permission]:
                                        !subItem.permissions[permission],
                                    },
                                  }
                                : subItem
                            ),
                          }
                        : {
                            permissions: {
                              ...row.permissions,
                              [permission]: !row.permissions[permission],
                            },
                          }),
                    }
                  : row
              ),
            }
          : group
      )
    );
  };

  const handleCreate = () => {
    // Validate the form before displaying the modal
    form
      .validateFields() // Validate form fields
      .then(() => {
        // If validation is successful, show the modal
        setModalVisible(true);

        // Hide the modal after 2 seconds and navigate to /settings-people
        setTimeout(() => {
          setModalVisible(false);
          navigate("/settings-people"); // Navigate after modal disappears
        }, 2000);
      })
      .catch((errorInfo) => {
        // If validation fails, log or handle errors here
        console.log("Validation failed:", errorInfo);
      });
  };

  return (
    <Styleddiv>
      <div>
        <div className="flex text-left gap-3">
          <p
            onClick={() => {
              navigate("/settings-people");
            }}
            className="people-type"
          >
            People Type
          </p>
          <RightOutlined className="w-[24px] h-[24px]" />
          <p className="creating-people-type">Editing People Type</p>
        </div>
        <br />
        <div>
          <Form
            form={form}
            name="custom-form"
            layout="vertical"
            onFinish={handleCreate}
          >
            <Form.Item
              name="Name"
              label={<span className="name-text">Name</span>}
              rules={[
                {
                  required: true,
                  message: "Please enter the name",
                },
              ]}
              style={{ textAlign: "left" }}
            >
              <Input />
            </Form.Item>

            <div>
              <div className="permission-text">Permission</div>
              <table style={{ width: "100%" }}>
                <thead className="multi_table_header">
                  <tr>
                    <th rowSpan="2" colSpan="2" className="text-left">
                      Menu Access Level
                    </th>
                    <th>Read</th>
                    <th rowSpan="1" colSpan="4">
                      Write
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center">View</th>
                    <th>Create</th>
                    <th>Modify</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {groups.map((group, groupIndex) => (
                    <React.Fragment key={group.name}>
                      <tr className="parent-row">
                        <td colSpan="6" className="parent-row" key={groupIndex}>
                          <div className="flex gap-3 text-left">
                            <span
                              className="!w-[14%]"
                              style={{
                                color: "#636980",
                                fontSize: "14px",
                                fontWeight: 400,
                              }}
                            >
                              {group.name}
                            </span>
                            <Switch
                              onChange={() => toggleVisibility(group.name)}
                            />
                          </div>
                        </td>
                      </tr>

                      {visibleGroups[group.name] && (
                        <tr>
                          <td colSpan="6">
                            <table className="!mt-0">
                              {group.subRows.map((subRow, rowIndex) => (
                                <React.Fragment key={rowIndex}>
                                  {subRow.name && (
                                    <tr>
                                      <td
                                        className="text-left"
                                        style={{
                                          color: "#636980",
                                          fontSize: "14px",
                                          fontWeight: 400,
                                        }}
                                      >
                                        {subRow.name}
                                      </td>
                                      <td>
                                        <Switch
                                          checked={subRow.permissions.view}
                                          onChange={() =>
                                            togglePermission(
                                              groupIndex,
                                              rowIndex,
                                              "view"
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <Switch
                                          checked={subRow.permissions.create}
                                          onChange={() =>
                                            togglePermission(
                                              groupIndex,
                                              rowIndex,
                                              "create"
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <Switch
                                          checked={subRow.permissions.modify}
                                          onChange={() =>
                                            togglePermission(
                                              groupIndex,
                                              rowIndex,
                                              "modify"
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <Switch
                                          checked={subRow.permissions.delete}
                                          onChange={() =>
                                            togglePermission(
                                              groupIndex,
                                              rowIndex,
                                              "delete"
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>
                                  )}
                                  {subRow.subItems &&
                                    subRow.subItems.length > 0 && (
                                      <React.Fragment>
                                        <tr className="!border-0">
                                          <td colSpan="5" className="!border-0">
                                            <div className="flex gap-3 items-center text-left">
                                              <p
                                                className="!w-[10%]"
                                                style={{
                                                  color: "#636980",
                                                  fontSize: "14px",
                                                  fontWeight: 400,
                                                }}
                                              >
                                                {subRow.subName}
                                              </p>
                                              <Switch
                                                onChange={() =>
                                                  toggleSubNamePermissions(
                                                    groupIndex,
                                                    rowIndex
                                                  )
                                                }
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan="5" className="!border-0">
                                            <table className="!m-0">
                                              {subRow.subItems.map(
                                                (subItem, subIndex) => (
                                                  <tr key={subIndex}>
                                                    <td
                                                      className="text-left"
                                                      style={{
                                                        color: "#636980",
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                      }}
                                                    >
                                                      {subItem.name}
                                                    </td>
                                                    <td>
                                                      <Switch
                                                        checked={
                                                          subItem.permissions
                                                            .view
                                                        }
                                                        onChange={() =>
                                                          togglePermission(
                                                            groupIndex,
                                                            rowIndex,
                                                            "view",
                                                            subIndex
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Switch
                                                        checked={
                                                          subItem.permissions
                                                            .create
                                                        }
                                                        onChange={() =>
                                                          togglePermission(
                                                            groupIndex,
                                                            rowIndex,
                                                            "create",
                                                            subIndex
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Switch
                                                        checked={
                                                          subItem.permissions
                                                            .modify
                                                        }
                                                        onChange={() =>
                                                          togglePermission(
                                                            groupIndex,
                                                            rowIndex,
                                                            "modify",
                                                            subIndex
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Switch
                                                        checked={
                                                          subItem.permissions
                                                            .delete
                                                        }
                                                        onChange={() =>
                                                          togglePermission(
                                                            groupIndex,
                                                            rowIndex,
                                                            "delete",
                                                            subIndex
                                                          )
                                                        }
                                                      />
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </table>
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    )}
                                </React.Fragment>
                              ))}
                            </table>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
            <br />
            <br />
            <div className="button-style">
              <Button
                className="cancel-button"
                onClick={() => {
                  navigate("/settings-people");
                }}
              >
                Cancel
              </Button>
              <Button
                className="save-button"
                type="primary"
                onClick={handleCreate}
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      </div>
      <Modal
        width={180}
        height={100}
        visible={modalVisible}
        footer={null}
        closable={false}
        centered
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            fontSize: "16px",
            fontWeight: "500",
            textAlign: "center",
          }}
        >
          <Tick style={{ width: "34px", height: "34px" }} />
          <p
            style={{
              fontSize: "16px",
              fontWeight: 400,
            }}
          >
            Saved
          </p>
        </div>
      </Modal>
    </Styleddiv>
  );
};

export default EditPeople;
